<div class='message-component'>{{message}} <mat-icon>done</mat-icon></div>